'use client'

import { AnimatePresence, motion } from 'motion/react'

import { easeShort, easeMedium } from '@/lib/transitions'

type ModalProps = React.HTMLAttributes<HTMLElement> & {
  trigger: React.ReactNode
  isVisible: boolean
  close: () => void
}

export default function Modal({ trigger, isVisible, close, children }: ModalProps) {
  return (
    <>
      {trigger}
      <AnimatePresence>
        {isVisible && (
          <motion.div
            initial={{ opacity: 0 }}
            animate={{ opacity: 1 }}
            exit={{ opacity: 0, transition: { delay: 0.15 } }}
            transition={easeShort}
            className="fixed left-0 top-0 z-[9999] flex h-dvh w-full items-start overflow-hidden px-3 pt-20"
          >
            <motion.div
              initial={{ y: 20, scale: 0.95 }}
              animate={{ y: 0, scale: 1 }}
              exit={{ y: 20, scale: 0.95 }}
              transition={easeMedium}
              className="relative z-50 max-h-[calc(100dvh-83px)] w-full overflow-y-auto rounded-xl rounded-t-xl bg-white transition-[height] duration-300 dark:border-x dark:border-t dark:border-white/10 dark:bg-black"
            >
              {children}
            </motion.div>

            <div
              className="absolute inset-0 z-0 bg-white/30 dark:bg-black/30"
              onClick={close}
            ></div>
          </motion.div>
        )}
      </AnimatePresence>
    </>
  )
}
